export const ETAPE_KEYS = {
    MOTIF: 'motif',
    STATUT_METIER_ASSO: 'statutMetierAsso',
    IDENTITE: 'identite',
    IDENTITE_RESPONSABLE_LEGAL: 'identiteResponsableLegal',
    IDENTITE_PERSONNE_MORALE: 'identitePersonneMorale',
    COORDONNEES_PERSONNE_PHYSIQUE: 'coordonneesPersonnePhysique',
    INFORMATIONS_PERSONNE_MORALE: 'informationPersonneMorale',
    ADRESSE_PRINCIPALE: 'adressePrincipale',
    ADRESSE_PRINCIPALE_RESPONSABLE_LEGAL: 'adressePrincipaleResponsableLegal',
    ADRESSE_SECONDAIRE: 'adresseSecondaire',
    ADRESSE_SECONDAIRE_RESPONSABLE_LEGAL: 'adresseSecondaireResponsableLegal',
    VALIDATION: 'validation',
    VALIDATION_EMAIL: 'validation-mail',
};

export const FLOW_KEYS = {
    REGULAR: 'identite',
    STATUT_METIER_ASSO: 'statutMetierAsso',
    MINEUR: 'mineur',
};
